var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#185edf",
    stroke: "#707070",
    d: "M184 150h17v17h-17z",
    "data-name": "Rectangle 141612"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-184 -150)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#185edf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.219 152.629h-11.224v1.87h11.224Z",
    "data-name": "Path 47783"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.219 156.368h-11.224v1.87h11.224Z",
    "data-name": "Path 47784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.995 160.108h7.479v1.87h-7.479Z",
    "data-name": "Path 47785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.405 161.067 1.323-1.322 1.983 1.983 3.967-3.966 1.317 1.321-5.289 5.289-3.301-3.305Z",
    "data-name": "Path 47786"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCheck);
export default __webpack_public_path__ + "static/media/Blue_check.c8c312995d4d0405a4cd27963f995504.svg";
export { ForwardRef as ReactComponent };